import { FC } from 'react';
import { Upload as FormUpload } from 'choerodon-ui/pro';

const Upload: FC<any> = (props) => {
  return <FormUpload disabled />;
};

export { Upload };
